import {
  CREATE_BATCHES_INSTITUTION_URL,
  DELETE_BATCH_INSTITUTION_URL,
  GET_ALL_BATCH_INSTITUTION_URL,
  GET_ALL_BATCH_TEACHER_INSTITUTION_URL,
  GET_BATCH_STUDENT_INSTITUTION_URL,
  NOT_ASSIGN_STUDENT_BATCH_INSTITUTION_URL,
  NOT_ASSIGN_TEACHER_INSTITUTION_URL,
  UPDATE_ASSIGN_BATCH_STUDENT_INSTITUTION_URL,
  UPDATE_BATCH_INSTITUTION_URL,
} from "../../apiurls/apiurls";

export const getAllBatchInstitution = async (token, course, params) => {
  const query = new URLSearchParams({
    course_key: String(course),
  });
  if (params.search) query.set("search", String(params.search));
  const url = `${GET_ALL_BATCH_INSTITUTION_URL}?${query.toString()}`;

  try {
    const response = await fetch(`${url}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching page for topic:", error);
    throw error;
  }
};

export const createBatchInstitution = async (token, payload) => {
  const url = `${CREATE_BATCHES_INSTITUTION_URL}`;

  try {
    const response = await fetch(`${url}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching page for topic:", error);
    throw error;
  }
};

export const updateBatchInstitution = async (token, payload, id) => {
  const url = `${UPDATE_BATCH_INSTITUTION_URL}?id=${id}`;

  try {
    const response = await fetch(`${url}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching page for topic:", error);
    throw error;
  }
};

export const deleteBatchInstitution = async (token, id) => {
  const url = `${DELETE_BATCH_INSTITUTION_URL}?id=${id}`;

  try {
    const response = await fetch(`${url}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching page for topic:", error);
    throw error;
  }
};

export const getAllBatchTeacherInstitution = async (token, params) => {
  const query = new URLSearchParams({});
  if (params.page) query.set("page", String(params.page));
  if (params.limit) query.set("limit", String(params.limit));
  if (params.search) query.set("search", String(params.search));
  if (params.batchId) query.set("batch_id", String(params.batchId));
  if (typeof params.disabled === "boolean")
    query.set("disabled", String(params.disabled));
  const url = `${GET_ALL_BATCH_TEACHER_INSTITUTION_URL}?${query.toString()}`;

  try {
    const response = await fetch(`${url}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching page for topic:", error);
    throw error;
  }
};

export const getAllBatchStudentInstitution = async (token, params) => {
  const query = new URLSearchParams({});
  if (params.page) query.set("page", String(params.page));
  if (params.limit) query.set("limit", String(params.limit));
  if (params.search) query.set("search", String(params.search));
  if (params.batchId) query.set("batch_id", String(params.batchId));
  if (params.grade) query.set("grade", String(params.grade));
  if (typeof params.disabled === "boolean")
    query.set("disabled", String(params.disabled));
  const url = `${GET_BATCH_STUDENT_INSTITUTION_URL}?${query.toString()}`;

  try {
    const response = await fetch(`${url}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching page for topic:", error);
    throw error;
  }
};

export const getNotAssignBatchTeacherInstitution = async (token, batchId) => {
  const url = `${NOT_ASSIGN_TEACHER_INSTITUTION_URL}?batch_id=${batchId}`;

  try {
    const response = await fetch(`${url}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching page for topic:", error);
    throw error;
  }
};

export const updateAssignBatchTeacherInstitution = async (
  token,
  payload,
  id
) => {
  const url = `${UPDATE_BATCH_INSTITUTION_URL}?id=${id}`;

  try {
    const response = await fetch(`${url}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching page for topic:", error);
    throw error;
  }
};

export const getNotAssignBatchStudentInstitution = async (token) => {
  const url = `${NOT_ASSIGN_STUDENT_BATCH_INSTITUTION_URL}`;

  try {
    const response = await fetch(`${url}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching page for topic:", error);
    throw error;
  }
};

export const updateAssignBatchStudentInstitution = async (token, payload) => {
  const url = `${UPDATE_ASSIGN_BATCH_STUDENT_INSTITUTION_URL}`;

  try {
    const response = await fetch(`${url}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching page for topic:", error);
    throw error;
  }
};
